import BreakShiftTab, {
    BreakShiftTabWithOffset
} from 'common/entity/components/dayShift/BreakShiftTab';
import breaksTabsFactory from 'common/components/common/breaks/BreakTabsFactory';

const BreakShiftTabs = breaksTabsFactory({ BreakTab: BreakShiftTab });
export const BreakShiftTabsWithOffset = breaksTabsFactory({
    BreakTab: BreakShiftTabWithOffset
});

export default BreakShiftTabs;
